export default {
  app: 'NebulaRec',
  common: {
    lang: 'Eng',
    call: 'Contact:',
    company: 'Zenith Palm Wireless Technology',
    mail: 'Business Email:',
    address: 'Address: Room 307, Building 7, Yalong Innovation Park, Jingan District, Shanghai',
    owner: 'Copyright Owner: Shanghai Zenith Palm Wireless Technology Co., Ltd',
    alertInfo1: 'Tap the top-right menu',
    alertInfo2: 'Open in browser to download'
  },
  videoPage: {
    eyebrow: 'Product Video',
    title: 'Discover NebulaRec in Minutes',
    description: 'Choose the Chinese or English version to learn about NebulaRec and how it works.',
    selectLanguage: 'Choose video language',
    chinese: '中文版',
    english: 'English',
    current: 'Now playing',
    unavailableTitle: 'Video coming soon',
    unavailableText: 'Your video will appear here as soon as it is ready.',
    hint: 'Play, pause, adjust volume, seek, or watch in fullscreen.',
    loadError: 'The video could not be loaded. Please try again later.'
  },
  banner: {
    slogan: 'Instant voice translation - Language is no longer a barrier!',
    slogan2: 'Intelligent recording, real-time transcription and translation, making communication boundless',
    download: 'Download Now'
  },
  introduction: {
    meeting: 'Meeting Notes',
    meetingIn: 'Real-time voice-to-text conversion, extensive meeting templates, mind mapping',
    translation: 'Real-time Translation',
    translationIn: 'Instant response, faster translation than ever',
    cross: 'Cross-platform Translation',
    crossIn: 'Transcending platform boundaries, translation always with you',
    offline: 'Offline Translation',
    offlineIn: 'Stay connected offline, translation always available'
  },
  scene: {
    title: 'Six Application Scenarios',
    meeting: '·Business Meetings',
    meetingIn: 'Multilingual meetings without barriers - real-time voice transcription accurately captures every decision point',
    travel: '·Travel Communication',
    travelIn: 'International travel without language barriers - adaptive accent recognition, clear transcription for both dialects and foreign languages',
    study: '·Education',
    studyIn: 'One-tap recording for foreign language classes/lectures, AI transcription + key point marking, doubling learning efficiency',
    exchange: '·International Socializing',
    exchangeIn: 'Record and translate instantly - making friends across borders at parties and gatherings',
    interview: '·Interviews & Research',
    interviewIn: 'Cross-language interview tool - original recording + instant translation, preserving every nuance of respondents\' answers',
    emergency: '·Emergency Situations',
    emergencyIn: 'For emergencies, press and hold to record - quick translation for medical/directions information ensures safety'
  },
  describe: {
    record: 'Voice Transcription: Accurate capture, instant text conversion',
    recordIn: 'Supports multiple major languages. With noise suppression and voice enhancement technology, AI-powered contextual correction improves accuracy even in noisy environments.',
    summary: 'AI Summarization: Extract essence, identify core insights',
    summaryIn: 'Integrated with ChatGPT, offering multiple formats to help users quickly extract key information, saving time and effort.',
    map: 'Mind Map Generation: Visual presentation, knowledge network construction',
    mapIn: 'Analyzes hierarchical relationships and logical connections in text, transforming them into visual mind maps that clearly present knowledge structures through nodes and connections.'
  },
  download: {
    apple: 'App Store',
    google: 'Google Play',
    honor: 'HONOR AppMarket',
    android: 'Android Download',
    huawei: 'Huawei APPGalley',
    mi: 'MI',
    oppo: 'OPPO',
    vivo: 'VIVO',
    appstore: 'Please go to the AppMarket to download'
  },
  share: {
    icode: 'Invitation Code',
    notice: 'After purchasing a cooperative recorder, you can redeem a friend invitation code in NebulaRec to receive free transcription time!',
    copy: 'Copy Invitation Code',
    success: '√ Copied'
  },
  hexinyingyong: {
    title: 'Core Features',
    t1: 'Real-time Transcription',
    j1: 'High accuracy, multi-language',
    t2: 'Real-time Translation',
    j2: 'Instant multilingual results',
    t3: 'Smart Summary',
    j3: 'AI-generated meeting notes',
    t4: 'Voiceprint Recognition',
    j4: 'Auto-distinguish speakers',
    t5: 'Knowledge Base',
    j5: 'Long-term file storage and intelligent Q&A',
    t6: 'Terminology Library',
    j6: 'Accurate transcription for professional domains',
    title2: 'Use Cases',
    t7: 'International Meetings',
    j7: 'Real-time recording & translation',
    t8: 'Cross-border E-commerce',
    j8: 'Seamless global communication',
    t9: 'Language Education',
    j9: 'Learning assistant & recorder',
    t10: 'Travel & Social',
    j10: 'Essential travel companion',
    t11: 'Team Collaboration',
    j11: 'Break language barriers',
    t12: 'Project Management',
    j12: 'Auto meeting documentation'
  }
}
